$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "events_self_service") {
    function filterMenu(searchTerm) {
      searchTerm = (searchTerm || "").trim().toLowerCase();

      // Always start by showing everything
      $(".menu-product-row.card-box").show();
      $(".product-group").show();
      $(".no-results").remove();

      // If empty search → we're done (everything visible)
      if (!searchTerm) {
        return;
      }

      let anyVisible = false;

      // Hide items that do NOT match
      $(".menu-product-row.card-box").each(function () {
        const $card = $(this);

        const title = $card.find(".product-title").text().toLowerCase();
        const description = $card
          .find(".product-description")
          .text()
          .toLowerCase();
        const allergens = $card.find(".allergens").text().toLowerCase();

        const matches =
          title.includes(searchTerm) ||
          description.includes(searchTerm) ||
          allergens.includes(searchTerm);

        if (matches) {
          anyVisible = true;
          // already visible from the .show() at the beginning
        } else {
          $card.hide();
        }
      });

      // Hide categories that have no visible products left
      $(".product-group").each(function () {
        const $group = $(this);
        const visibleCount = $group.find(
          ".menu-product-row.card-box:visible",
        ).length;
        if (visibleCount === 0) {
          $group.hide();
        }
      });

      const visibleCards = $(".menu-product-row.card-box:visible");

      if (visibleCards.length === 1 && $("#location-products").attr("data-search-and-add-to-checkout") == 1) {
        visibleCards.first().trigger("click");
        $("#clear-search-product-button").trigger("click");
        return;
      }

      // Show "no results" message only if nothing matched
      if (!anyVisible) {
        const msg = `
            <div class="no-results text-center my-5 py-4">
                <h5>Ingen produkter funnet for "<strong>${searchTerm}</strong>"</h5>
                <p class="text-muted">Prøv forskjellige søkeord</p>
            </div>
        `;
        $("#product-list-with-category").append(msg);
      }
      $("#clear-search-product-button").removeClass("d-none");
    }

    $(document).on("submit", ".product-search-form", function (e) {
      e.preventDefault();
      const value = $(this).find('input[name="search_string"]').val().trim();
      filterMenu(value);
      // Optional: focus back on input
      $(this).find('input[name="search_string"]').focus();
    });

    $(document).on("click", ".category-nav-link", function (e) {
      const locationId = parseInt($("#location-products").data("location-id"));
      const formData = new FormData();
      $("#search_string").val("");
      const categoryName = $(this).data("category-name") || "";
      formData.append("search_string", "");
      formData.append("category_name", categoryName);
      formData.append("event_id", locationId);

      $.ajax({
        type: "POST",
        url: "/ajax/events_self_service/get_all_products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $(".product-group").hide();
            } else {
              $(".product-group").show();
            }
            $("#product-group-").html(data.html);
            $('[data-toggle="tooltip"]').tooltip(); // re-init
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    // Mobile search toggle functionality
    $(document).on(
      "click",
      "#mobile-search-toggle-dine-in-mobile",
      function (e) {
        $(".product-order-search-form-dine-in").slideToggle(300);
        // Focus on the search input when shown
        setTimeout(function () {
          if ($(".product-order-search-form-dine-in").is(":visible")) {
            $("#search_string").focus();
          } else {
            $("#clear-search-product-button").trigger("click");
          }
        }, 350);
      },
    );

    $(document).on("click", "#clear-search-product-button", function (e) {
      e.preventDefault();
      $("#search_string").val("");
      $(this).addClass("d-none");
      $(".product-search-form").trigger("submit");
      $("#search_string").focus();
      $(".no-results").remove();
    });
  }
});
